import {
    useInfiniteQuery,
    useMutation,
    useQuery,
    useQueryClient,
    useSuspenseQuery,
} from "@tanstack/react-query";

export const useQueryClientCustom = useQueryClient;

export const useQueryCustom = useSuspenseQuery;

export const useMutationCustom = useMutation;

export const useQueryCustomNoSuspense = useQuery;

export const useInfiniteQueryCustom = useInfiniteQuery;
